window.addEventListener('DOMContentLoaded', () => {
    const menuItemsWithChildren = document.querySelectorAll("ul#menu-header-menu>.menu-item-has-children")
    menuItemsWithChildren.forEach((menuItem) => {
        const link = menuItem.querySelector("a");

        link.addEventListener("click", (e) => {
            const isMobile = window.matchMedia("(max-width: 768px)").matches;

            if (isMobile) {
                e.preventDefault();
            }
        });
    });

    function handleResize() {
        const container = document.querySelector(".icon-burger-container");
        const menuSeparator = document.querySelector(".menu-separator");

        if (window.innerWidth > 768) {
            if (container) {
                const icon = container.querySelector(".icon");
                const burger = container.querySelector(".header-menu__burger");
                const menuText = container.querySelector("p");

                if (icon) menuSeparator.insertAdjacentElement("beforebegin", icon);
                if (burger) menuSeparator.insertAdjacentElement("beforebegin", burger);
                if (menuText) menuSeparator.insertAdjacentElement("beforebegin", menuText);

                container.remove();
            }
        }
    }

    handleResize();
    window.addEventListener("resize", handleResize);
})